import { render, staticRenderFns } from "./MandatosForm.vue?vue&type=template&id=47eb2480&scoped=true&"
import script from "./MandatosForm.vue?vue&type=script&lang=js&"
export * from "./MandatosForm.vue?vue&type=script&lang=js&"
import style0 from "./MandatosForm.vue?vue&type=style&index=0&id=47eb2480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb2480",
  null
  
)

export default component.exports